<template>
  <b-tooltip
    position="is-top"
    multilined
    append-to-body
    type="is-info"
    class="is-light"
  >
    <span class="leaderboard-score">{{ cumulativeScore.cumulativeTotal }}</span>
    <template v-slot:content>
      <div class="cumulative-breakdown">
        <div class="breakdown-header">
          <strong>Cumulative Score Breakdown</strong>
        </div>

        <div
          v-if="cumulativeScore.lectureBreakdowns.length === 0"
          class="no-data"
        >
          No lecture data available
        </div>

        <div v-else>
          <div
            v-for="(lecture, index) in cumulativeScore.lectureBreakdowns"
            :key="lecture.lectureId"
            class=""
          >
            <div class="lecture-header">
              <strong>Lecture {{ index + 1 }}</strong>
              <span class="lecture-date">{{ formatDate(lecture.date) }}</span>
            </div>

            <table class="has-text-right lecture-table">
              <tr
                v-for="(item, itemIndex) in lecture.scoreItems.filter(
                  (item) => item.count
                )"
                :key="item.label + item.unit"
                :class="{ 'has-text-grey': item.count === 0 }"
              >
                <td class="has-text-left is-italic pr-2">
                  {{
                    itemIndex &&
                    item.label === lecture.scoreItems[itemIndex - 1].label
                      ? ""
                      : item.label
                  }}
                </td>
                <td class="has-text-left">{{ item.count }} {{ item.unit }}</td>
                <td>&nbsp;×&nbsp;</td>
                <td>{{ item.multiplier }}</td>
                <td>&nbsp;=&nbsp;</td>
                <td>{{ item.points }}</td>
              </tr>
              <tr class="lecture-total">
                <td colspan="4"><strong>Lecture Total</strong></td>
                <td>&nbsp;=&nbsp;</td>
                <td>
                  <strong>{{ lecture.total }}</strong>
                </td>
              </tr>
            </table>
          </div>

          <div class="cumulative-total">
            <table class="has-text-right">
              <tr style="border-top: 2px solid #333">
                <td colspan="4"><strong>Cumulative Total</strong></td>
                <td>&nbsp;=&nbsp;</td>
                <td>
                  <strong>{{ cumulativeScore.cumulativeTotal }}</strong>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </template>
  </b-tooltip>
</template>

<script>
export default {
  name: "ClassLeaderboardScore",

  props: {
    cumulativeScore: {
      type: Object,
      required: true,
    },
  },

  methods: {
    formatDate(dateString) {
      if (!dateString) return "Unknown date";

      try {
        const date = new Date(dateString);
        return date.toLocaleDateString();
      } catch (error) {
        return dateString;
      }
    },
  },
};
</script>

<style scoped>
.leaderboard-score {
  cursor: help;
  font-weight: bold;
  color: #007bff;
  background-color: #e3f2fd;
  padding: 0;
  border-radius: 2px;
  display: inline-block;
  min-width: 2rem;
  line-height: 2rem;
  text-align: center;
}

.cumulative-breakdown {
  max-width: 400px;
  max-height: 500px;
  overflow-y: auto;
}

.breakdown-header {
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #ddd;
}

.no-data {
  color: #666;
  font-style: italic;
}

.lecture-breakdown {
  margin-bottom: 1rem;
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.lecture-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.lecture-date {
  font-size: 0.8rem;
  color: #666;
}

.lecture-topic {
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 0.5rem;
  font-style: italic;
}

.lecture-table {
  width: 100%;
  font-size: 0.9rem;
}

.lecture-total {
  border-top: 1px solid #bbb;
}

.cumulative-total {
  margin-top: 1rem;
  padding-top: 0.5rem;
}
</style>
